/**
 * The six report queues, one per kind of content, under the name each has in
 * the API's URLs (`/moderator/reports/posts`).
 *
 * They are separate and nothing sorts across them, so the counts beside each
 * one are what says where to look first.
 */
export const REPORT_QUEUES = [
  { slug: 'posts', label: 'Publications' },
  { slug: 'comments', label: 'Commentaires' },
  { slug: 'events', label: 'Événements' },
  { slug: 'reviews', label: 'Avis' },
  { slug: 'providers', label: 'Fiches' },
  { slug: 'offers', label: 'Offres' },
];

export const isReportQueue = (slug) => REPORT_QUEUES.some((queue) => queue.slug === slug);

/**
 * The queue to open first: the first holding offensive content, else the first
 * with anything waiting, else the first of all.
 *
 * @param {Record<string, {pending: number, urgent: number}>|null|undefined} counts
 */
export function firstReportQueue(counts) {
  const urgent = REPORT_QUEUES.find((queue) => (counts?.[queue.slug]?.urgent ?? 0) > 0);
  const waiting = REPORT_QUEUES.find((queue) => (counts?.[queue.slug]?.pending ?? 0) > 0);

  return (urgent || waiting || REPORT_QUEUES[0]).slug;
}
